<div class="container" [class.edit]="editMode" *ngIf="!isLoading">
    <div class="header">
        {{ (editMode ? 'editor.library.dialog.edit.title' : 'editor.library.dialog.create.title') | translate }}
    </div>
    <div class="main">
        <div class="description-container" *ngIf="!editMode">
            {{ 'editor.library.dialog.shipyard.description-1' | translate }}
            <br />
            <br />
            {{ 'editor.library.dialog.shipyard.description-2' | translate }}
        </div>
        <div class="shipyard main-container">
            <app-input-select-with-error
                class="wider-input"
                [initialValue]="shipyardName"
                [legend]="'editor.library.dialog.shipyard.legend'"
                [propertyName]="SHIPYARD_INPUT_NAME"
                [optionsArray]="shipyardNames"
                [maxLength]="50"
                [placeholder]="'editor.library.dialog.shipyard.placeholder'"
                (onInputUpdated)="selectShipyard($event)"
                [validatorFunction]="shipyardValidatorFunction()"
                [removeBackground]="true"></app-input-select-with-error>
        </div>
        <div class="name main-container">
            <app-channel-text-input
                class="library-name"
                [name]="NAME_INPUT_NAME"
                [value]="libraryName"
                [label]="'editor.library.dialog.name.legend'"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [maxlength]="NAME_MAX_LEN"
                [inputError]="validationErrors?.name"></app-channel-text-input>
        </div>
    </div>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="disabledSaveButton()"
                [text]="editMode ? 'editor.library.dialog.edit.button' : 'editor.library.dialog.create.button'"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="save()"></app-button>
        </div>
    </div>
</div>

<app-loading-spinner
    *ngIf="isLoading"
    class="spinner-component"
    [class.edit]="editMode"
    [custom]="true"
    size="80"
    strokeWidth="3"></app-loading-spinner>
